/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchParcelGeometryDto } from '../../models/search-parcel-geometry-dto';

export interface SearchForParcelGeometryByPfiList$Params {
  pfi: Array<string>;
}

export function searchForParcelGeometryByPfiList(
  http: HttpClient,
  rootUrl: string,
  params: SearchForParcelGeometryByPfiList$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchParcelGeometryDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    searchForParcelGeometryByPfiList.PATH,
    'get',
  );
  if (params) {
    rb.query('pfi', params.pfi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchParcelGeometryDto>;
      }),
    );
}

searchForParcelGeometryByPfiList.PATH = '/search/parcel/geometry';
